module.exports = __webpack_public_path__ + "img/540.4bbd8f84.jpg";